export const urls = {
  GET_KONTAKT: 'KontaktiKupca/vrati_kontakte_kupca_za_id',
  INSERT_KONTAKT: 'KontaktiKupca/unos_kontakta_kupca',
  UPDATE_KONTAKT: 'KontaktiKupca/izmena_kontakta_kupca',
  DELETE_KONTAKT: 'KontaktiKupca/brisanje_kontakta_kupca',
};
